import React from "react";

import { MyEventsWrapper } from "../../components";
import { ModalsProvider } from "../../components/PurchaseFlow/NewCheckoutWrapper/providers/ModalsProvider";

export default function MyEventsPage() {
  return (
    <ModalsProvider>
      <MyEventsWrapper />
    </ModalsProvider>
  );
}
